import { Pipe, PipeTransform } from '@angular/core';
import { NormalizerHelper } from 'src/app/core/helpers/normalizer.helper';

@Pipe({
  name: 'whatsAppLink',
})
export class WhatsappLinkPipe implements PipeTransform {
  transform(telefone: string): string {
    return NormalizerHelper.whatsAppLink(telefone);
  }
}
